/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';

@Component({
    selector: 'app-modal-cell-editor',
    styleUrls: ['./cell-renderer.component.scss'],
    template: `
    <button pButton type="button" label="{{label}}" (click)="showModal()"></button>
  `,
    standalone: false
})
export class ModalCellEditorComponent {
  params: any;
  label = 'Open Modal';
  constructor() {
  }

  agInit(params: any): void {
    this.params = params;
    if (this.params.label) {
      this.label = this.params.label;
    }
  }

  showModal() {
    this.params.openModal(this.params);
  }
}
